// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Detect and Remove Date Picker Autofill
$('.gfield .datepicker').each(function () {
  $(this).attr('autocomplete', 'off');
});

jQuery(document).ready(function($) {
  const headerBookButton = $('#header-book-button'),
        headerDropdownButtons = $('.header-dropdown-buttons');
  let activate = function() {
    headerDropdownButtons.addClass('active');
  }

  let deactivate = function() {
    headerDropdownButtons.removeClass('active');
  }


  headerDropdownButtons.hover(activate, deactivate);
  headerBookButton.hover(activate, deactivate);




});




// WEBPACK FOOTER //
// ./scripts/main.js